/**
 * Cross-tab sync over `BroadcastChannel`.
 *
 * Feature-detected: absent on React Native / Hermes and some embedded webviews,
 * where the client simply runs without cross-tab sync. Nothing here touches the
 * DOM or a global at import time.
 */

import type { AuthBroadcastMessage, BroadcastChannelLike } from "./types";

export const DEFAULT_BROADCAST_CHANNEL = "plerity-auth";

/** Open the platform `BroadcastChannel`, or null when unavailable / construction throws. */
export function openBroadcastChannel(name: string): BroadcastChannelLike | null {
  try {
    const Ctor = (globalThis as { BroadcastChannel?: new (n: string) => BroadcastChannelLike }).BroadcastChannel;
    return typeof Ctor === "function" ? new Ctor(name) : null;
  } catch {
    return null;
  }
}

/**
 * Validate an incoming channel payload. Only the two message types with a
 * numeric `at` are accepted; any other shape (including extra keys) is ignored.
 */
export function parseBroadcastMessage(data: unknown): AuthBroadcastMessage | null {
  if (typeof data !== "object" || data === null) return null;
  const { type, at } = data as { type?: unknown; at?: unknown };
  if ((type !== "signed-out" && type !== "refreshed") || typeof at !== "number") return null;
  return { type, at };
}
